import { notNil } from '../typescriptUtils';
import './customerOfferForm.scss';

const replaceFormContents = (form: HTMLFormElement) => {
  let successElement = null;
  let successElementSelector = form.getAttribute('data-success-element');
  if (successElementSelector !== null) {
    successElement = document.querySelector(successElementSelector);
    successElement && (successElement.style.display = '');
  } else {
    const successMessageText = form.getAttribute('data-success-message') || 'Thank you for signing up.';
    const successMessageHtml = successMessageText.replaceAll('|', '<br />');
    successElement = document.createElement('p');
    successElement.className = 'successMessage large-p';
    successElement.innerHTML = successMessageHtml;
  }

  //@ts-expect-error
  form.replaceChildren(successElement);
};

const prepareFormToBeSuccessContainer = (form: HTMLFormElement) => {
  const originalHeight = form.clientHeight;
  const originalWidth = form.clientWidth;
  form.style.minHeight = originalHeight + 'px';
  form.style.width = originalWidth + 'px';
  form.classList.add('successfulCustomerOfferForm');
};

const sendAjax = (form: HTMLFormElement) => {
  if (!window?.wizUrl) return console.warn('wizUrl is not defined');

  const fields = Object.fromEntries(new FormData(form).entries()) as Record<string, string>;
  const endpoint = `https://${window.wizUrl}/offer-enroll`;

  const requestBody = {
    ...fields,
    tags: fields.tags?.toString().split(',') ?? [''],
    accepts_marketing:
      notNil(fields.accepts_marketing) &&
      ['1', 'true', 'yes', 'on', ''].includes(fields.accepts_marketing.toLowerCase())
        ? 'true'
        : 'false',
  };
  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(requestBody),
  };

  form.classList.add('loadingCustomerOfferForm');
  fetch(endpoint, options)
    .then(function (response) {
      if (response.ok) {
        return response.json();
      }
      return Promise.reject(response);
    })
    .then(function (successfulData) {
      prepareFormToBeSuccessContainer(form);
      replaceFormContents(form);
      // console.log({ successfulData });
    })
    .catch(function (error) {
      alert('Sorry, something went wrong. Verify your email address?');
      console.warn('Something went wrong.', error);
    })
    .finally(() => {
      form.classList.remove('loadingCustomerOfferForm');
    });
};

const handleOfferEnroll = (event: Event) => {
  event.preventDefault();
  event.stopPropagation();
  const form = event.currentTarget as HTMLFormElement;
  if (form) {
    sendAjax(form);
  }
};

export const exposeCustomerOfferFormHandler = () => {
  window.handleOfferEnroll = handleOfferEnroll;
};
